import { render, staticRenderFns } from "./PartnerEin.vue?vue&type=template&id=30884117"
import script from "./PartnerEin.vue?vue&type=script&lang=js"
export * from "./PartnerEin.vue?vue&type=script&lang=js"
import style0 from "./PartnerEin.vue?vue&type=style&index=0&id=30884117&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports